import { styled } from '@linaria/react';

import { P } from '~components/Typography';
import { gradientText, hoverable, withBlurBg } from '~theme/snippets';

export const PremiumContainer = styled.div<{ visible: boolean }>`
	display: flex;
	visibility: ${({ visible }) => (visible ? 'visible' : 'hidden')};
	@media screen and (max-width: 560px) {
		display: none;
	}
`;

export const PremiumDiv = styled.div`
	${withBlurBg({ blur: 25, opacity: false, botGradient: true })};
	${hoverable};
	&:before {
		transform: scaleY(0.6);
	}

	svg {
		position: relative;
	}
`;

export const PremiumText = styled(P)`
	${gradientText};
	user-select: none;
`;
